import { render, staticRenderFns } from "./PolicyMenu.vue?vue&type=template&id=46273353&scoped=true"
var script = {}
import style0 from "./PolicyMenu.vue?vue&type=style&index=0&id=46273353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46273353",
  null
  
)

export default component.exports